import ProviderListv2WithState from "./ProviderListv2WithState";

const ProviderListv2 = ({ caseInfo, providerInfo, loading, setReFetchStaticBar }) => {
  return (
    <ProviderListv2WithState
      caseInfo={caseInfo}
      providerInfo={providerInfo}
      loading={loading}
    />
  );
};

export default ProviderListv2;
